export default "assets/images/logo-black-d3b991f4.png";